export const PANDASCORE_LANG_TO_LOCALE: Record<string, string> = {
  en: 'en-US',
  fr: 'fr-FR',
  ru: 'uk-UA', // 'ru-RU',
  sv: 'sv-SE',
  fi: 'fi-FI',
  uk: 'uk-UA',
  pt: 'pt-BR',
  ko: 'ko-KR'
};

export enum PandascoreBlock {
  GENERAL_STATS = 'name',
  HEAD_TO_HEAD = 'head-to-head',
  FORM_GUIDE = 'form-guide',
  TEAM_STATS = 'teams-stats',
  PLAYER_STATS = 'players-stats'
}
